import { default as React, useContext } from "react";


import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { ValidationReductionsDto } from "core/backend/data";
import classNames from "classnames";
import { MultiSelectItem } from "components/multiselect";
import { keys } from "ts-transformer-keys";

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    data: ValidationReductionsDto[];
    hubs: MultiSelectItem[];
}

const List = ({ t, data, hubs, scrollPosition }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));

    const keysInDto = keys<ValidationReductionsDto>();
    const dtoHubs = hubs.filter((x) => keysInDto.some((key) => key.toLowerCase().endsWith(x.id.toLowerCase())));

    return (
        <table id="datatable">
            <thead>
                <tr>
                    <th className="fixedDateColumn fixedHeader" style={{ top: top + "px", left: left + "px" }}></th>
                    <th colSpan={7} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:cnecWithIva")}</th>
                    <th colSpan={10} className="tableTitles fixedHeader lineLeft" style={{ top: top + "px" }}>{t("page_validationReductions:violatedLimits")}</th>
                    <th colSpan={1 + (dtoHubs.length)} className="tableTitles fixedHeader lineLeft" style={{ top: top + "px" }}>{t("page_validationReductions:circumstance")}</th>
                    <th colSpan={1} className="tableTitles fixedHeader lineLeft" style={{ top: top + "px" }}>{t("page_validationReductions:fallback")}</th>
                </tr>
                <tr>
                    <th className="fixedDateColumn" style={{ top: top + "px", left: left + "px" }}>{t("common:Date")}</th>

                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:tso")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:cnecName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:direction")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:returnedBranch")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:iva")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:ivaShare")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:justification")}</th>

                    <th className={classNames("fixedHeader", "lineLeft")} style={{ top: top + "px" }}>{t("page_validationReductions:overloadedTso")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:overloadedCnec")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:overloadedEic")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:overloadedFromUct")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:overloadedToUct")}</th>
                    <th className={classNames("fixedHeader", "lineLeft")} style={{ top: top + "px" }}>{t("page_validationReductions:contingencyNr")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:contingencyName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:contingencyTso")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:contingencyFromUct")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_validationReductions:contingencyToUct")}</th>

                    {dtoHubs.map((hub, i) => <th key={hub.id} className={classNames("fixedHeader", i == 0 ? "lineLeft" : "")} style={{ top: top + "px" }}>{t("page_validationReductions:coreNp") + t("common_hubs:" + hub.id)}</th>)}
                    
                    <th className={classNames("fixedHeader", "lineLeft")}  style={{ top: top + "px" }}>{t("page_validationReductions:comment")}</th>
                    
                    <th className={classNames("fixedHeader", "lineLeft")} style={{ top: top + "px" }}>{t("page_validationReductions:fallbackApplied")}</th>
                </tr>
            </thead>
            <tbody>
                {
                    data && data.map((d) => <Row key={d.id} dto={d} hubs={dtoHubs} left={left} />)
                }
            </tbody>
        </table>
    );
};

const translated = withTranslation("page_validationReductions")(List);

export default translated;